import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {
    AbstractControl,
    FormGroup,
} from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ui-value-primary-hints',
    templateUrl: './ui-value-primary-hints.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiValuePrimaryHintsComponent implements OnInit, OnDestroy {
    @Input()
    form!: FormGroup;
    @Input()
    name!: string;

    public control!: AbstractControl;

    private _destroyed$ = new Subject();

    constructor(private _cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.control = this.form.get(this.name)!;

        this.control.statusChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(() => this._cd.markForCheck());
    }

    ngOnDestroy() {
        this._destroyed$.next();
    }
}
